export interface QueryParamListBase {
  order_by: string;
  order_direction: 'asc' | 'desc';
  per_page: number | string;
  page: string | number;
}
